import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { BUDGET_TYPE, BUDGET_RECURRENCE, BILLING_TYPE as _BILLING_TYPE } from 'src/boot/constants';
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import Project from 'src/store/models/Project';
import { dialog } from 'src/boot/mixins.js';
import { colorUtils } from 'src/mixins/colors-utils';
import User from 'src/store/models/User';
import Phase from 'src/store/models/Phase';
import Tags from 'src/components/TagManagement';
import ProjectBudgetManagement from 'src/components/ProjectBudgetManagement';
import budgetManagement from 'src/mixins/budget-management';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [dialog, colorUtils, budgetManagement],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker,
    ProjectBudgetManagement: ProjectBudgetManagement,
    Tags: Tags,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    onComplete: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    client_id: {
      type: Number,
      default: function _default() {
        return -1;
      }
    },
    name: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      step: 1,
      selectedUsers: [],
      phasesOptions: [],
      filteredPhases: [],
      tagLists: [],
      tagKey: 1,
      selectedSection: 'project-details',
      hourlyRateVisible: false,
      billingTypeOptions: [{
        value: _BILLING_TYPE.TIME_MATERIAL,
        label: this.$t('general.time_and_material'),
        caption: this.$t('general.bill_by_hour')
      }, {
        value: _BILLING_TYPE.FIXED_FEE,
        label: this.$t('general.fixed_fee'),
        caption: this.$t('general.bill_a_set_price')
      }, {
        value: _BILLING_TYPE.NOT_BILLABLE,
        label: this.$t('general.non_billable'),
        caption: this.$t('general.not_billable_to_client')
      }],
      project: {
        name: '',
        color: null,
        client_id: -1,
        is_public: 0,
        users: [],
        hourly_rate: 0,
        billing_type: _BILLING_TYPE.NOT_BILLABLE,
        is_billable: 0,
        tag_usage: 'ALL_TAGS',
        requires_tags: false,
        phases: [{
          is_open: 1,
          name: this.$t('components.projectDialog.general'),
          budget_minutes: 0
        }],
        budget: null,
        project_type: 'phases'
      }
    };
  },
  watch: {
    'project.billing_type': function projectBilling_type(val) {
      // the project is considered billable only if the billing type is time_material
      this.project.is_billable = val === _BILLING_TYPE.TIME_MATERIAL;

      if (this.budgetType === 'monetary') {
        if (val === _BILLING_TYPE.FIXED_FEE || val === _BILLING_TYPE.TIME_MATERIAL) {
          this.project.hourly_rate = 0;
          this.project.budget.type = BUDGET_TYPE.REVENUE;
        } else if (val === _BILLING_TYPE.NOT_BILLABLE) {
          if (this.me.is_owner) {
            this.project.budget.type = BUDGET_TYPE.COST;
          } else {
            this.budgetType = 'time';
          }
        }
      }
    },
    'project.budget.recurrence': function projectBudgetRecurrence(val, oldVal) {
      if (this.budgetType !== 'none') {
        if (this.project.budget.interval > 6 && oldVal) {
          this.project.budget.interval = 1;
        }
      }
    },
    'project.budget.interval': function projectBudgetInterval(val, oldVal) {
      if (val < 0) {
        this.project.budget.interval = 1;
      }
    },
    'project.api_only': function projectApi_only(val, oldVal) {
      if (oldVal !== null && val !== oldVal) {
        this.$emit('apiset');
      }
    },
    project: {
      handler: function handler(val, oldVal) {
        if (val.is_active === oldVal.is_active) {
          this.$emit('edited');
        }
      },
      deep: true
    }
  },
  computed: {
    BILLING_TYPE: function BILLING_TYPE() {
      return _BILLING_TYPE;
    },
    sendBudgetThresholdEmail: {
      get: function get() {
        return !!this.project.budget.alert_threshold;
      },
      set: function set(val) {
        if (!val) {
          this.project.budget.alert_threshold = null;
        } else {
          this.project.budget.alert_threshold = 75;
        }
      }
    },
    budgetType: {
      get: function get() {
        if (!this.project.budget) return 'none';
        if (this.project.budget.type === BUDGET_TYPE.TIME) return 'time';else return 'monetary';
      },
      set: function set(val) {
        if (val === 'none') {
          this.project.budget = null;
        } else {
          if (!this.project.budget) {
            this.project.budget = {
              budget_minutes: 0,
              recurrence: BUDGET_RECURRENCE.NONE,
              interval: 1,
              alert_threshold: 0,
              include_expenses: false
            };
          }

          if (val === 'time') {
            this.project.budget.type = BUDGET_TYPE.TIME;
          } else if (this.project.billing_type === _BILLING_TYPE.NOT_BILLABLE) {
            this.project.budget.type = BUDGET_TYPE.COST;
          } else {
            this.project.budget.type = BUDGET_TYPE.REVENUE;
          }
        }
      }
    },
    budgetRecurrence: {
      get: function get() {
        return !!this.project.budget.recurrence;
      },
      set: function set(val) {
        if (!val) {
          this.project.budget.recurrence = BUDGET_RECURRENCE.NONE;
        } else {
          this.project.budget.recurrence = BUDGET_RECURRENCE.MONTHLY;
          this.project.budget.interval = 1;
        }
      }
    },
    projectUsers: function projectUsers() {
      return User.query().with('avatar').whereIdIn(this.project.users).get();
    },
    userOnlyGM: function userOnlyGM() {
      return this.me.is_gm && !(this.me.is_admin || this.me.is_owner);
    },
    groupManagerUsers: function groupManagerUsers() {
      return User.query().with('avatar').where('group_id', this.me.group_id).get();
    }
  },
  methods: {
    onHourlyRateClick: function onHourlyRateClick() {
      if (!this.me.account.hasFeatureAccess('billables_advanced')) {
        this.$refs.hourlyRateUpgrade.showTooltip();
        return;
      }

      this.hourlyRateVisible = true;
    },
    onBillingTypeClick: function onBillingTypeClick(value) {
      if (value === _BILLING_TYPE.FIXED_FEE && !this.me.account.hasFeatureAccess('fixed_fee_projects')) {
        this.$refs.fixedFeeUpgrade.showTooltip();
      } else if (value === _BILLING_TYPE.TIME_MATERIAL && !this.me.account.hasFeatureAccess('billables')) {
        this.$refs.timeMaterialUpgrade.showTooltip();
      }
    },
    togglePublicProject: function togglePublicProject(isPublic) {
      this.selectedSection = 'project-details';

      if (isPublic) {
        this.project.users = User.query().where('enabled', 1).orderBy('name', 'asc').get().map(function (user) {
          return user.user_id;
        });
      } else {
        this.project.users = [this.me.user_id];
      }

      this.updateSelectedUsers(this.project.users);
    },
    saveProject: function saveProject() {
      var _this = this;

      // TODO needs improvements
      Project.api().post('/projects', _objectSpread(_objectSpread({}, this.project), {}, {
        tag_lists: this.project.tag_usage === 'LINKED_TAGS' ? this.tagLists : [],
        users: this.selectedUsers
      })).then(function (result) {
        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'project_create', {}); // HUBSPOT

          window._hsq.push(['setPath', 'project/create']);

          window._hsq.push(['trackPageView']);

          if (_this.$gtag) {
            _this.$gtag.event('project_create', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }

        _this.$q.notify({
          message: _this.$t('components.projectDialog.created_project'),
          type: 'positive'
        });

        _this.onOKClick(result.response.data);

        _this.onComplete(result.response.data);
      }).catch(function () {});
    },
    getUser: function getUser(userId) {
      return this.projectUsers.find(function (user) {
        return user.user_id === userId;
      });
    },
    updateProjectUsers: function updateProjectUsers(users) {
      var _this2 = this;

      users.forEach(function (user) {
        return _this2.project.users.push(user.user_id);
      });
    },
    updateSelectedUsers: function updateSelectedUsers(users) {
      var _this3 = this;

      if (users) {
        users.forEach(function (userId) {
          var index = _this3.selectedUsers.findIndex(function (u) {
            return u.user_id === userId;
          });

          if (index === -1) {
            _this3.selectedUsers.push({
              user_id: userId,
              budget_minutes: null,
              is_pm: null,
              hourly_rate: null
            });
          }
        });
      } else {
        if (this.selectedUsers.findIndex(function (u) {
          return u.id === _this3.me.user_id;
        }) === -1) {
          // If the user deselected everyone, let's add the user himself (if not present)
          this.selectedUsers.push({
            user_id: this.me.user_id,
            budget_minutes: null,
            is_pm: null,
            hourly_rate: null
          });
        }

        this.project.users = [this.me.user_id];
      }

      this.selectedUsers = this.selectedUsers.filter(function (selectedUser, idx) {
        // If the user deselected everyone, let's keep the user himself
        if (!users) {
          return selectedUser.user_id === _this3.me.user_id;
        }

        var index = users.indexOf(selectedUser.user_id);

        if (index === -1) {
          return false;
        }

        return true;
      });
    },
    removeUser: function removeUser(userId) {
      var index = this.project.users.indexOf(userId);
      this.project.users.splice(index, 1);
      this.updateSelectedUsers(this.project.users);
    },
    createPhase: function createPhase(val, done) {
      if (val.length > 0) {
        var phase = this.phasesOptions.find(function (po) {
          return po.name.toLowerCase() === val.toLowerCase();
        });

        if (!phase) {
          phase = {
            name: val,
            is_open: 1,
            budget_minutes: 0
          };
          this.phasesOptions.push(phase);
        }

        done(phase, 'add-unique');
      }
    },
    filterPhases: function filterPhases(val, update) {
      var _this4 = this;

      if (val === '') {
        update(function () {
          _this4.filteredPhases = _this4.phasesOptions;
        });
      } else {
        Phase.api().get('/phases', {
          params: {
            text: val,
            sort_by: 'project_count',
            group_by: 'name',
            direction: 'desc',
            per_page: 10
          }
        }).then(function (_ref) {
          var response = _ref.response;
          update(function () {
            _this4.filteredPhases = _this4.mapPhasesResponse(response.data.data);
          });
        }).catch(function () {});
      }
    },
    mapPhasesResponse: function mapPhasesResponse(data) {
      return data.map(function (phase) {
        return {
          name: phase.name,
          is_open: 1,
          budget_minutes: 0
        };
      });
    },
    onPhasesSelected: function onPhasesSelected(phases) {
      this.project.phases = phases;
    },
    phasesUpdated: function phasesUpdated(value) {
      this.$refs.phasesSelect.updateInputValue('');
    },
    changeRecurrence: function changeRecurrence(val) {
      if (val === 1) {
        this.project.budget.interval = '0';
      } else if (val === 2) {
        this.project.budget.interval = 1;
      } else {
        this.project.budget.interval = -1;
      }
    },
    loadTagLists: function loadTagLists(selectedItems) {
      var _this5 = this;

      this.tagKey++;
      this.tagLists = _toConsumableArray(selectedItems.map(function (tagList) {
        var myTagList = _this5.tagLists.find(function (myTagList) {
          return tagList.tag_list_id === myTagList.tag_list_id;
        });

        tagList.pivot = myTagList ? myTagList.pivot : {
          required: false
        };
        return tagList;
      }));
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.userOnlyGM) {
      User.api().get('/users', {
        params: {
          group_id: this.me.group_id
        }
      }).then(function () {
        _this6.project.users = _this6.groupManagerUsers.map(function (u) {
          return u.user_id;
        });

        _this6.updateSelectedUsers(_this6.project.users);
      }).catch(function () {});
    } else {
      this.project.users = [this.me.user_id];
      this.updateSelectedUsers(this.project.users);
    }

    this.project.name = this.name;
    this.project.client_id = this.client_id;
    this.project.color = this.getRandomColor();

    if (this.me.account.hasFeatureAccess('billables')) {
      this.billing_type = _BILLING_TYPE.TIME_MATERIAL;
    } // this.$root.$on('refresh-users', () => {
    //   this.$refs.groups.loadGroups()
    //   this.$refs.groups.loadUsers()
    // })


    Phase.api().get('/phases', {
      params: {
        group_by: 'name',
        sort_by: 'project_count',
        direction: 'desc',
        per_page: 10
      }
    }).then(function (_ref2) {
      var response = _ref2.response;
      _this6.phasesOptions = _this6.mapPhasesResponse(response.data.data);
    }).catch(function () {});
  }
};